import { useCallback } from 'react'

import { useCohortInfo } from 'hooks/useCohortInfo'
import { useExperimentalFeatures } from 'hooks/useExperimentalFeatures'

import { ISubscription } from 'models/subscriptions.model'

import { Cohort, SubscriptionProduct } from 'root-constants'

export const useShouldShowRebillPeriod = (): ((
  subscription: ISubscription,
) => boolean) => {
  const { cohortToUse } = useCohortInfo()
  const {
    isAyah56Test,
    isBlessedPath2271C3TrialTest,
    isKarmaPath13C3dTrialTest,
  } = useExperimentalFeatures()

  const is3DayTrialMonetizationTest =
    isBlessedPath2271C3TrialTest || isKarmaPath13C3dTrialTest
  const showTrialDurationBadge = cohortToUse === Cohort.KP_BS_13_CC

  return useCallback(
    (subscription) => {
      if (isAyah56Test) {
        return (
          subscription.mainPrices.periodQuantity === 3 &&
          subscription.trialPrices.durationDays ===
            SubscriptionProduct.ONE_MONTH
        )
      }
      return is3DayTrialMonetizationTest || showTrialDurationBadge
    },
    [isAyah56Test, is3DayTrialMonetizationTest, showTrialDurationBadge],
  )
}
